// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --pd-root-opacity: 0;
  --pd-root-cursor: auto;
  --pd-root-min-height: 0px;
  --pd-lvl-0-color: initial;
  --pd-lvl-1-color: green;
  --pd-lvl-2-color: orange;
  --pd-lvl-3-color: red;
  --pd-view-resize: none;
  --pd-view-height: 0px;
  --pd-view-min-height: 0px;
  --pd-view-max-height: 0px;
  --pd-border-width: 1px;
  --pd-border-color: var(--vscode-notebook-cellBorderColor, var(--jp-border-color1, initial));
  --pd-background-color: var(--vscode-notebook-editorBackground, var(--jp-layout-color0, initial));
  --pd-select-color: var(--vscode-notebook-selectedCellBackground, var(--jp-rendermime-table-row-hover-background, initial));
  --pd-header-color: initial;
  --pd-body-padding-top: 0px;
  --pd-body-padding-bottom: 0px;
  --pd-body-td-max-width: 1ch;
  --pd-footer-padding-top: 12px;
  --pd-footer-padding-bottom: 7px;
  --pd-footer-max-width: 0px;
  --pd-filter-opacity: 0;
}
.pd-ipypandas {
  background-color: transparent;
}
.pd-ipypandas .pd-root {
  margin: 0;
  padding: 0;
  overflow: hidden;
  min-height: var(--pd-root-min-height);
  opacity: var(--pd-root-opacity);
  cursor: var(--pd-root-cursor);
}
.pd-ipypandas .pd-root .pd-panel .pd-message {
  overflow-y: auto;
  max-height: 70px;
}
.pd-ipypandas .pd-root .pd-panel .pd-message.pd-expanded {
  max-height: initial;
}
.pd-ipypandas .pd-root .pd-panel .pd-message p {
  margin: 0;
  padding: 0;
}
.pd-ipypandas .pd-root .pd-panel .pd-message p.pd-lvl-0 {
  color: var(--pd-lvl-0-color);
}
.pd-ipypandas .pd-root .pd-panel .pd-message p.pd-lvl-1 {
  color: var(--pd-lvl-1-color);
}
.pd-ipypandas .pd-root .pd-panel .pd-message p.pd-lvl-2 {
  color: var(--pd-lvl-2-color);
}
.pd-ipypandas .pd-root .pd-panel .pd-message p.pd-lvl-3 {
  color: var(--pd-lvl-3-color);
}
.pd-ipypandas .pd-root .pd-view {
  height: 0;
  overflow: auto;
  resize: var(--pd-view-resize);
  height: var(--pd-view-height);
  min-height: var(--pd-view-min-height);
  max-height: var(--pd-view-max-height);
}
.pd-ipypandas .pd-root .pd-view .pd-table {
  margin: 0;
  padding: 0;
}
.pd-ipypandas .pd-root .pd-view .pd-table thead {
  top: 0;
  z-index: 2;
  position: sticky;
}
.pd-ipypandas .pd-root .pd-view .pd-table thead.pd-styled {
  box-shadow: 0 var(--pd-border-width) var(--pd-border-color);
  background-color: var(--pd-header-color);
}
.pd-ipypandas .pd-root .pd-view .pd-table thead.pd-styled tr {
  background-color: var(--pd-header-color);
}
.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]) {
  white-space: nowrap;
}
.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]) .pd-col-text {
  white-space: nowrap;
  margin: 0px 2px;
}
.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]) .pd-col-text[draggable='true'] {
  cursor: grab;
}
.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]) .pd-col-i-rescale {
  overflow: hidden;
  transition: opacity 0.5s;
  opacity: 0;
}
.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]) .pd-col-i-rescale::after {
  content: '‖';
  z-index: 3;
  width: 16px;
  height: 16px;
  text-align: center;
  position: absolute;
  pointer-events: none;
  display: inline-block;
  background-color: var(--pd-header-color);
  transform: translate(-18px, 0px);
}
.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]) .pd-col-i-rescale span {
  resize: horizontal;
  overflow: hidden;
  display: inline-block;
  margin: 0px 2px;
  height: 8px;
}
.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]) .pd-col-i-rescale span::before {
  content: '';
  width: 18px;
  display: inline-block;
}
.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]) .pd-col-i-sort {
  transition: opacity 0.5s;
  opacity: 0;
}
.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]) .pd-col-i-sort span::before {
  content: '';
  display: inline-block;
  border: solid;
  transform: rotate(0deg);
  border-width: 0px 0px 2px 0px;
  margin: 0px 4px 3px 0px;
  padding: 2px 3px;
}
.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]) .pd-col-i-filter {
  transition: opacity 0.5s;
  opacity: 0;
}
.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]) .pd-col-i-filter span::before {
  content: '⋮';
  display: inline-block;
  font-size: 14px;
  width: 6px;
}
.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]).pd-sort-desc .pd-col-i-sort {
  transition: none;
  opacity: 1;
}
.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]).pd-sort-desc .pd-col-i-sort span::before {
  transform: rotate(45deg);
  border-width: 0px 2px 2px 0px;
  margin-bottom: 3px;
  padding: 2px;
}
.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]).pd-sort-asc .pd-col-i-sort {
  transition: none;
  opacity: 1;
}
.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]).pd-sort-asc .pd-col-i-sort span::before {
  transform: rotate(45deg);
  border-width: 2px 0px 0px 2px;
  margin-bottom: 0px;
  padding: 2px;
}
.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]).pd-filter-active .pd-col-i-filter {
  transition: none;
  opacity: 1;
}
.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]).pd-dragover {
  background-color: var(--pd-select-color);
}
.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]).pd-dragover .pd-col-i-rescale::after {
  background-color: transparent;
}
.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]).pd-dragover .pd-col-i-rescale span {
  opacity: 0;
}
.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]):hover {
  cursor: pointer;
}
.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]):hover .pd-col-i-rescale {
  opacity: 1;
  cursor: col-resize;
}
.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]):hover .pd-col-i-sort {
  opacity: 1;
  cursor: pointer;
}
.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]):hover .pd-col-i-filter {
  opacity: 1;
  cursor: context-menu;
}
.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-index {
  left: 0;
  z-index: 2;
  position: sticky;
  background-color: var(--pd-header-color);
}
.pd-ipypandas .pd-root .pd-view .pd-table tbody::before {
  content: '';
  display: table-row;
  height: var(--pd-body-padding-top);
}
.pd-ipypandas .pd-root .pd-view .pd-table tbody::after {
  content: '';
  display: table-row;
  height: var(--pd-body-padding-bottom);
}
.pd-ipypandas .pd-root .pd-view .pd-table tbody tr th.pd-row-head {
  left: 0;
  z-index: 1;
  position: sticky;
  white-space: nowrap;
  background-color: var(--pd-header-color);
}
.pd-ipypandas .pd-root .pd-view .pd-table tbody tr th.pd-row-head .pd-row-text {
  white-space: nowrap;
}
.pd-ipypandas .pd-root .pd-view .pd-table tbody tr th.pd-row-head:last-of-type {
  box-shadow: calc(-1 * var(--pd-border-width)) 0 var(--pd-border-color) inset;
}
.pd-ipypandas .pd-root .pd-view .pd-table tbody tr th.pd-row-head:not([rowspan]).pd-select-active {
  background-color: var(--pd-select-color);
}
.pd-ipypandas .pd-root .pd-view .pd-table tbody tr th.pd-row-head:not([rowspan]).pd-select-active ~ td.pd-data {
  background-color: var(--pd-select-color);
}
.pd-ipypandas .pd-root .pd-view .pd-table tbody tr th.pd-row-head:not([rowspan]):hover {
  cursor: pointer;
  background-color: var(--pd-select-color);
}
.pd-ipypandas .pd-root .pd-view .pd-table tbody tr:hover th[rowspan] {
  background-color: var(--pd-header-color);
}
.pd-ipypandas .pd-root .pd-view .pd-table tbody tr:hover th:not([rowspan]) {
  background-color: var(--pd-select-color);
}
.pd-ipypandas .pd-root .pd-view .pd-table.pd-empty {
  display: none;
}
.pd-ipypandas .pd-root .pd-view .pd-table.pd-truncated tbody td {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: var(--pd-body-td-max-width);
}
.pd-ipypandas .pd-root .pd-footer {
  display: flex;
  flex-direction: row;
  padding-top: var(--pd-footer-padding-top);
  padding-bottom: var(--pd-footer-padding-bottom);
  max-width: var(--pd-footer-max-width);
  margin: 0;
}
.pd-ipypandas .pd-root .pd-footer .pd-shape {
  flex: 0 0 auto;
}
.pd-ipypandas .pd-root .pd-footer .pd-shape p {
  white-space: nowrap;
  margin: 0;
}
.pd-ipypandas .pd-root .pd-footer .pd-search {
  flex: 1 0 auto;
}
.pd-ipypandas .pd-root .pd-footer .pd-search input {
  float: right;
  font-size: inherit;
  font-family: inherit;
  line-height: normal;
  border: var(--pd-border-width) solid var(--pd-border-color);
  background: transparent;
  box-shadow: none;
  color: inherit;
  width: 180px;
  margin-left: 10px;
  padding: 2px 3px 2px 3px;
  transition: opacity 0.5s;
  opacity: 0;
}
.pd-ipypandas .pd-root .pd-footer .pd-search input:focus {
  outline: 0;
}
.pd-ipypandas .pd-root .pd-footer .pd-search:hover input,
.pd-ipypandas .pd-root .pd-footer .pd-search.pd-search-active input {
  opacity: 1;
}
.pd-ipypandas .pd-root .pd-filter {
  z-index: 3;
  position: absolute;
  background: var(--pd-header-color);
  border: var(--pd-border-width) solid var(--pd-border-color);
  padding: 3px 6px 3px 6px;
  margin: 0;
  opacity: var(--pd-filter-opacity);
  transition: opacity 0.5s;
}
.pd-ipypandas .pd-root.pd-touch .pd-view .pd-table thead th.pd-col-head .pd-col-i-rescale {
  opacity: 1;
}
.pd-ipypandas .pd-root.pd-touch .pd-view .pd-table thead th.pd-col-head .pd-col-i-sort {
  opacity: 1;
}
.pd-ipypandas .pd-root.pd-touch .pd-view .pd-table thead th.pd-col-head .pd-col-i-filter {
  opacity: 1;
}
.pd-ipypandas .pd-root.pd-touch .pd-footer .pd-search input {
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,sBAAsB;EACtB,yBAAyB;EACzB,yBAAyB;EACzB,uBAAuB;EACvB,wBAAwB;EACxB,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,sBAAsB;EACtB,2FAA2F;EAC3F,gGAAgG;EAChG,0HAA0H;EAC1H,0BAA0B;EAC1B,0BAA0B;EAC1B,6BAA6B;EAC7B,2BAA2B;EAC3B,6BAA6B;EAC7B,+BAA+B;EAC/B,0BAA0B;EAC1B,sBAAsB;AACxB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,qCAAqC;EACrC,+BAA+B;EAC/B,6BAA6B;AAC/B;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,SAAS;EACT,cAAc;EACd,6BAA6B;EAC7B,6BAA6B;EAC7B,qCAAqC;EACrC,qCAAqC;AACvC;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,MAAM;EACN,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,2DAA2D;EAC3D,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,UAAU;EACV,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,wCAAwC;EACxC,gCAAgC;AAClC;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,eAAe;EACf,WAAW;AACb;AACA;EACE,WAAW;EACX,WAAW;EACX,qBAAqB;AACvB;AACA;EACE,wBAAwB;EACxB,UAAU;AACZ;AACA;EACE,WAAW;EACX,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,6BAA6B;EAC7B,uBAAuB;EACvB,gBAAgB;AAClB;AACA;EACE,wBAAwB;EACxB,UAAU;AACZ;AACA;EACE,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,UAAU;AACZ;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,wBAAwB;EACxB,6BAA6B;EAC7B,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,UAAU;EACV,kBAAkB;AACpB;AACA;EACE,UAAU;EACV,eAAe;AACjB;AACA;EACE,UAAU;EACV,oBAAoB;AACtB;AACA;EACE,OAAO;EACP,UAAU;EACV,gBAAgB;EAChB,wCAAwC;AAC1C;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,kCAAkC;AACpC;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;AACvC;AACA;EACE,OAAO;EACP,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,wCAAwC;AAC1C;AACA;EACE,mBAAmB;AACrB;AACA;EACE,4EAA4E;AAC9E;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,eAAe;EACf,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,wCAAwC;AAC1C;AACA;EACE,aAAa;AACf;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,+CAA+C;EAC/C,qCAAqC;EACrC,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,cAAc;AAChB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,2DAA2D;EAC3D,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;EACxB,wBAAwB;EACxB,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;;EAEE,UAAU;AACZ;AACA;EACE,UAAU;EACV,kBAAkB;EAClB,kCAAkC;EAClC,2DAA2D;EAC3D,wBAAwB;EACxB,SAAS;EACT,iCAAiC;EACjC,wBAAwB;AAC1B;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ;AACA;EACE,UAAU;AACZ","sourcesContent":[":root {\n  --pd-root-opacity: 0;\n  --pd-root-cursor: auto;\n  --pd-root-min-height: 0px;\n  --pd-lvl-0-color: initial;\n  --pd-lvl-1-color: green;\n  --pd-lvl-2-color: orange;\n  --pd-lvl-3-color: red;\n  --pd-view-resize: none;\n  --pd-view-height: 0px;\n  --pd-view-min-height: 0px;\n  --pd-view-max-height: 0px;\n  --pd-border-width: 1px;\n  --pd-border-color: var(--vscode-notebook-cellBorderColor, var(--jp-border-color1, initial));\n  --pd-background-color: var(--vscode-notebook-editorBackground, var(--jp-layout-color0, initial));\n  --pd-select-color: var(--vscode-notebook-selectedCellBackground, var(--jp-rendermime-table-row-hover-background, initial));\n  --pd-header-color: initial;\n  --pd-body-padding-top: 0px;\n  --pd-body-padding-bottom: 0px;\n  --pd-body-td-max-width: 1ch;\n  --pd-footer-padding-top: 12px;\n  --pd-footer-padding-bottom: 7px;\n  --pd-footer-max-width: 0px;\n  --pd-filter-opacity: 0;\n}\n.pd-ipypandas {\n  background-color: transparent;\n}\n.pd-ipypandas .pd-root {\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  min-height: var(--pd-root-min-height);\n  opacity: var(--pd-root-opacity);\n  cursor: var(--pd-root-cursor);\n}\n.pd-ipypandas .pd-root .pd-panel .pd-message {\n  overflow-y: auto;\n  max-height: 70px;\n}\n.pd-ipypandas .pd-root .pd-panel .pd-message.pd-expanded {\n  max-height: initial;\n}\n.pd-ipypandas .pd-root .pd-panel .pd-message p {\n  margin: 0;\n  padding: 0;\n}\n.pd-ipypandas .pd-root .pd-panel .pd-message p.pd-lvl-0 {\n  color: var(--pd-lvl-0-color);\n}\n.pd-ipypandas .pd-root .pd-panel .pd-message p.pd-lvl-1 {\n  color: var(--pd-lvl-1-color);\n}\n.pd-ipypandas .pd-root .pd-panel .pd-message p.pd-lvl-2 {\n  color: var(--pd-lvl-2-color);\n}\n.pd-ipypandas .pd-root .pd-panel .pd-message p.pd-lvl-3 {\n  color: var(--pd-lvl-3-color);\n}\n.pd-ipypandas .pd-root .pd-view {\n  height: 0;\n  overflow: auto;\n  resize: var(--pd-view-resize);\n  height: var(--pd-view-height);\n  min-height: var(--pd-view-min-height);\n  max-height: var(--pd-view-max-height);\n}\n.pd-ipypandas .pd-root .pd-view .pd-table {\n  margin: 0;\n  padding: 0;\n}\n.pd-ipypandas .pd-root .pd-view .pd-table thead {\n  top: 0;\n  z-index: 2;\n  position: sticky;\n}\n.pd-ipypandas .pd-root .pd-view .pd-table thead.pd-styled {\n  box-shadow: 0 var(--pd-border-width) var(--pd-border-color);\n  background-color: var(--pd-header-color);\n}\n.pd-ipypandas .pd-root .pd-view .pd-table thead.pd-styled tr {\n  background-color: var(--pd-header-color);\n}\n.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]) {\n  white-space: nowrap;\n}\n.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]) .pd-col-text {\n  white-space: nowrap;\n  margin: 0px 2px;\n}\n.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]) .pd-col-text[draggable='true'] {\n  cursor: grab;\n}\n.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]) .pd-col-i-rescale {\n  overflow: hidden;\n  transition: opacity 0.5s;\n  opacity: 0;\n}\n.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]) .pd-col-i-rescale::after {\n  content: '‖';\n  z-index: 3;\n  width: 16px;\n  height: 16px;\n  text-align: center;\n  position: absolute;\n  pointer-events: none;\n  display: inline-block;\n  background-color: var(--pd-header-color);\n  transform: translate(-18px, 0px);\n}\n.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]) .pd-col-i-rescale span {\n  resize: horizontal;\n  overflow: hidden;\n  display: inline-block;\n  margin: 0px 2px;\n  height: 8px;\n}\n.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]) .pd-col-i-rescale span::before {\n  content: '';\n  width: 18px;\n  display: inline-block;\n}\n.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]) .pd-col-i-sort {\n  transition: opacity 0.5s;\n  opacity: 0;\n}\n.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]) .pd-col-i-sort span::before {\n  content: '';\n  display: inline-block;\n  border: solid;\n  transform: rotate(0deg);\n  border-width: 0px 0px 2px 0px;\n  margin: 0px 4px 3px 0px;\n  padding: 2px 3px;\n}\n.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]) .pd-col-i-filter {\n  transition: opacity 0.5s;\n  opacity: 0;\n}\n.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]) .pd-col-i-filter span::before {\n  content: '⋮';\n  display: inline-block;\n  font-size: 14px;\n  width: 6px;\n}\n.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]).pd-sort-desc .pd-col-i-sort {\n  transition: none;\n  opacity: 1;\n}\n.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]).pd-sort-desc .pd-col-i-sort span::before {\n  transform: rotate(45deg);\n  border-width: 0px 2px 2px 0px;\n  margin-bottom: 3px;\n  padding: 2px;\n}\n.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]).pd-sort-asc .pd-col-i-sort {\n  transition: none;\n  opacity: 1;\n}\n.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]).pd-sort-asc .pd-col-i-sort span::before {\n  transform: rotate(45deg);\n  border-width: 2px 0px 0px 2px;\n  margin-bottom: 0px;\n  padding: 2px;\n}\n.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]).pd-filter-active .pd-col-i-filter {\n  transition: none;\n  opacity: 1;\n}\n.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]).pd-dragover {\n  background-color: var(--pd-select-color);\n}\n.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]).pd-dragover .pd-col-i-rescale::after {\n  background-color: transparent;\n}\n.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]).pd-dragover .pd-col-i-rescale span {\n  opacity: 0;\n}\n.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]):hover {\n  cursor: pointer;\n}\n.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]):hover .pd-col-i-rescale {\n  opacity: 1;\n  cursor: col-resize;\n}\n.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]):hover .pd-col-i-sort {\n  opacity: 1;\n  cursor: pointer;\n}\n.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-col-head:not([colspan]):hover .pd-col-i-filter {\n  opacity: 1;\n  cursor: context-menu;\n}\n.pd-ipypandas .pd-root .pd-view .pd-table thead tr th.pd-index {\n  left: 0;\n  z-index: 2;\n  position: sticky;\n  background-color: var(--pd-header-color);\n}\n.pd-ipypandas .pd-root .pd-view .pd-table tbody::before {\n  content: '';\n  display: table-row;\n  height: var(--pd-body-padding-top);\n}\n.pd-ipypandas .pd-root .pd-view .pd-table tbody::after {\n  content: '';\n  display: table-row;\n  height: var(--pd-body-padding-bottom);\n}\n.pd-ipypandas .pd-root .pd-view .pd-table tbody tr th.pd-row-head {\n  left: 0;\n  z-index: 1;\n  position: sticky;\n  white-space: nowrap;\n  background-color: var(--pd-header-color);\n}\n.pd-ipypandas .pd-root .pd-view .pd-table tbody tr th.pd-row-head .pd-row-text {\n  white-space: nowrap;\n}\n.pd-ipypandas .pd-root .pd-view .pd-table tbody tr th.pd-row-head:last-of-type {\n  box-shadow: calc(-1 * var(--pd-border-width)) 0 var(--pd-border-color) inset;\n}\n.pd-ipypandas .pd-root .pd-view .pd-table tbody tr th.pd-row-head:not([rowspan]).pd-select-active {\n  background-color: var(--pd-select-color);\n}\n.pd-ipypandas .pd-root .pd-view .pd-table tbody tr th.pd-row-head:not([rowspan]).pd-select-active ~ td.pd-data {\n  background-color: var(--pd-select-color);\n}\n.pd-ipypandas .pd-root .pd-view .pd-table tbody tr th.pd-row-head:not([rowspan]):hover {\n  cursor: pointer;\n  background-color: var(--pd-select-color);\n}\n.pd-ipypandas .pd-root .pd-view .pd-table tbody tr:hover th[rowspan] {\n  background-color: var(--pd-header-color);\n}\n.pd-ipypandas .pd-root .pd-view .pd-table tbody tr:hover th:not([rowspan]) {\n  background-color: var(--pd-select-color);\n}\n.pd-ipypandas .pd-root .pd-view .pd-table.pd-empty {\n  display: none;\n}\n.pd-ipypandas .pd-root .pd-view .pd-table.pd-truncated tbody td {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  max-width: var(--pd-body-td-max-width);\n}\n.pd-ipypandas .pd-root .pd-footer {\n  display: flex;\n  flex-direction: row;\n  padding-top: var(--pd-footer-padding-top);\n  padding-bottom: var(--pd-footer-padding-bottom);\n  max-width: var(--pd-footer-max-width);\n  margin: 0;\n}\n.pd-ipypandas .pd-root .pd-footer .pd-shape {\n  flex: 0 0 auto;\n}\n.pd-ipypandas .pd-root .pd-footer .pd-shape p {\n  white-space: nowrap;\n  margin: 0;\n}\n.pd-ipypandas .pd-root .pd-footer .pd-search {\n  flex: 1 0 auto;\n}\n.pd-ipypandas .pd-root .pd-footer .pd-search input {\n  float: right;\n  font-size: inherit;\n  font-family: inherit;\n  line-height: normal;\n  border: var(--pd-border-width) solid var(--pd-border-color);\n  background: transparent;\n  box-shadow: none;\n  color: inherit;\n  width: 180px;\n  margin-left: 10px;\n  padding: 2px 3px 2px 3px;\n  transition: opacity 0.5s;\n  opacity: 0;\n}\n.pd-ipypandas .pd-root .pd-footer .pd-search input:focus {\n  outline: 0;\n}\n.pd-ipypandas .pd-root .pd-footer .pd-search:hover input,\n.pd-ipypandas .pd-root .pd-footer .pd-search.pd-search-active input {\n  opacity: 1;\n}\n.pd-ipypandas .pd-root .pd-filter {\n  z-index: 3;\n  position: absolute;\n  background: var(--pd-header-color);\n  border: var(--pd-border-width) solid var(--pd-border-color);\n  padding: 3px 6px 3px 6px;\n  margin: 0;\n  opacity: var(--pd-filter-opacity);\n  transition: opacity 0.5s;\n}\n.pd-ipypandas .pd-root.pd-touch .pd-view .pd-table thead th.pd-col-head .pd-col-i-rescale {\n  opacity: 1;\n}\n.pd-ipypandas .pd-root.pd-touch .pd-view .pd-table thead th.pd-col-head .pd-col-i-sort {\n  opacity: 1;\n}\n.pd-ipypandas .pd-root.pd-touch .pd-view .pd-table thead th.pd-col-head .pd-col-i-filter {\n  opacity: 1;\n}\n.pd-ipypandas .pd-root.pd-touch .pd-footer .pd-search input {\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
